import React, {
    useState,
    useMemo
} from "react";

import {
    Drawer,
    InputNumber,
    Select,
    Card,
    Statistic,
    Row,
    Col
} from "antd";

const DeliveryEstimation = ({
                                open,
                                onClose,
                                product
                            }) => {

    const [distance, setDistance] =
        useState(100);

    const [transportType, setTransportType] =
        useState("truck");

    const estimatedPrice =
        useMemo(() => {

            const coefficient =
                transportType === "truck"
                    ? 150
                    : 300;

            return (
                distance *
                coefficient
            );

        }, [
            distance,
            transportType
        ]);

    return (

        <Drawer
            title="🚚 Estimation livraison"
            width={700}
            open={open}
            onClose={onClose}
        >

            <Row gutter={16}>

                <Col span={12}>

                    <InputNumber
                        style={{ width: "100%" }}
                        value={distance}
                        onChange={setDistance}
                        placeholder="Distance Km"
                    />

                </Col>

                <Col span={12}>

                    <Select
                        style={{ width: "100%" }}
                        value={transportType}
                        onChange={setTransportType}
                        options={[
                            {
                                value: "truck",
                                label: "Camion"
                            },
                            {
                                value: "pickup",
                                label: "Pickup"
                            }
                        ]}
                    />

                </Col>

            </Row>

            <Card
                style={{
                    marginTop: 20
                }}
            >

                <Statistic
                    title="Coût estimatif"
                    value={estimatedPrice}
                    suffix="XOF"
                />

            </Card>

        </Drawer>

    );
};

export default DeliveryEstimation;